import React, { useEffect, useState } from 'react'
import { useBlocker } from 'react-router'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

type LeavePageConfirmationDialogComponent = React.FC<{
    isDirty: boolean
}>

export const LeavePageConfirmationDialog: LeavePageConfirmationDialogComponent = ({ isDirty = false }) => {
    const [navigateConfirmModal, setNavigateConfirmModal] = useState(false)

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isDirty) {
                e.preventDefault()
                e.returnValue = ''
                return true // Return a truthy value
            }
            return null // Allow navigation if no conditions met
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => window.removeEventListener('beforeunload', handleBeforeUnload)
    }, [isDirty])

    const shouldBlockNavigation = ({
        currentLocation,
        nextLocation,
    }: {
        currentLocation: { pathname: string }
        nextLocation: { pathname: string }
    }) => {
        if (currentLocation.pathname === nextLocation.pathname) {
            return false
        }
        if (isDirty) {
            setNavigateConfirmModal(true)
            return true
        }
        return false
    }

    const blocker = useBlocker(shouldBlockNavigation)

    if (!navigateConfirmModal) return null
    return (
        <Dialog open={true}>
            <DialogTitle>Ändringar ej sparade</DialogTitle>
            <DialogContent>Är du säker på att du vill lämna? Du har osparade ändringar!</DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        setNavigateConfirmModal(false)
                    }}
                >
                    Avbryt
                </Button>
                <Button
                    onClick={() => {
                        if (blocker?.proceed) {
                            blocker.proceed()
                        }
                    }}
                >
                    Fortsätt
                </Button>
            </DialogActions>
        </Dialog>
    )
}
